import React from 'react'
import PropTypes from 'prop-types'
import Checkbox from '../elements/Checkbox'

const TermsOfUseCheckbox = (props) => {
    return (
        <Checkbox
            name='termsOfUse'
            errors={props.errors}
            value={props.value}
            handleClick={props.handleClick}
        >
            {props.children}I have reviewed the {props.termsUrl.length > 0 ? <React.Fragment><a href={props.termsUrl} target='_blank'>Terms of Use</a> and </React.Fragment> : ''}<a href={props.cisUrl} target='_blank'>Critical Information Summary</a> and have agreed to make this purchase.
        </Checkbox>
    )
}

TermsOfUseCheckbox.propTypes = {
    errors: PropTypes.object.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
    handleClick: PropTypes.func.isRequired,
    cisUrl: PropTypes.string,
    termsUrl: PropTypes.string.isRequired
}

export default TermsOfUseCheckbox



// WEBPACK FOOTER //
// ./resources/js/components/TermsOfUseCheckbox.js